import request from '@/utils/request'

// 我的成就

let BadgeUserApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.badge_user/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.badge_user/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.badge_user/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.badge_user/edit', data, errorback);
    }
}

export default BadgeUserApi;



// WEBPACK FOOTER //
// ./src/api/study/badge_user.js